import { useState } from 'react'
import { faArrowDownToLine, faSpinner } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import download from 'api/areas/download'
import Button, { ButtonSizes } from 'design-system/button'
import { downloadFile } from 'helpers/downloadFile.helper'
import { useTranslationRankmi } from 'helpers/translations.helper'
import { FilterGroup } from 'helpers/filterData.helper'
import { IAreaModel } from 'models/area.model'
import { useAccess } from 'contexts/AccessContext'
import WithoutPermissionsReports from 'components/tooltips/WithoutPermissionsReports'
import { ErrorToast } from '../ui/toast/toastsTemplates'
import { prefix } from './constants'
import { useSelectedItems } from './context'

interface DownloadReportProps {
  filters: Record<string, string | string[]>[] | FilterGroup[]
  area?: IAreaModel | null
}

export const DownloadReport = ({ filters, area }: DownloadReportProps) => {
  const [loading, setLoading] = useState(false)
  const tRelative = useTranslationRankmi({ prefix })
  const areaIds = useSelectedItems()

  const {
    permissions: { canDownload },
  } = useAccess()

  const disabled = !canDownload

  return (
    <div className="d-block w-100">
      <div className="d-flex justify-content-end">
        <div className="d-flex align-items-start">
          <Button
            disabled={loading || disabled}
            size={ButtonSizes.Small}
            onClick={async () => {
              setLoading(true)
              try {
                const { data } = await download({
                  q: { id_in: areaIds.map(Number), g: filters },
                  idOrParentId: area?.id.toString(),
                })
                downloadFile(data)
              } catch {
                ErrorToast(tRelative('toasts.errorReport'))
              }
              setLoading(false)
            }}
          >
            {loading ? (
              <FontAwesomeIcon icon={faSpinner} spin className="mr-1" />
            ) : (
              <FontAwesomeIcon
                className="mr-2"
                size="lg"
                icon={faArrowDownToLine}
              />
            )}
            {tRelative('report')}
          </Button>
          {!canDownload && (
            <div className="mx-2">
              <WithoutPermissionsReports />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
